var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "bg-cover h-full pb-10 bg-opacity-10",
      style: { backgroundImage: `url(${_vm.image})` },
    },
    [
      _c("div", { staticClass: "max-w-6xl mx-auto p-4 lg:px-8 xl:px-0" }, [
        _c(
          "div",
          { staticClass: "max-w-2xl mx-auto mt-10 bg-white rounded-md" },
          [
            _c(
              "div",
              {
                staticClass:
                  "flex justify-center text-gray-600 font-semibold text-xl md:p-6 p-4",
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("registration-for-content-provider")) +
                    "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _c("main-register", {
              on: { registerSuccess: _vm.mainRegisterSuccess },
            }),
            _vm._v(" "),
            _vm.isMainRegister
              ? _c("ValidationObserver", {
                  attrs: { slim: "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function ({ handleSubmit, invalid }) {
                          return [
                            _c(
                              "form",
                              {
                                attrs: { novalidate: "" },
                                on: {
                                  submit: function ($event) {
                                    $event.preventDefault()
                                    return handleSubmit(_vm.onSubmit)
                                  },
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "grid grid-cols-2 bg-white rounded-md p-6 gap-4",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex justify-start col-span-2 text-gray-600 font-semibold text-xl",
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.$t("additional-information")
                                            ) +
                                            "\n            "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "md:col-span-1 col-span-2",
                                      },
                                      [
                                        _c(
                                          "label",
                                          {
                                            staticClass:
                                              "block mb-1 text-sm font-medium text-gray-700",
                                            attrs: { for: "organization-name" },
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.$t("organization-name")
                                                ) +
                                                "*"
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("ValidationProvider", {
                                          attrs: {
                                            name: "organization_name",
                                            rules: "required",
                                            mode: "eager",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function ({ errors }) {
                                                  return [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.company.name,
                                                          expression:
                                                            "company.name",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "focus:outline-none appearance-none block w-full px-3 py-2 border rounded-md shadow-sm placeholder-gray-400 sm:text-sm",
                                                      class:
                                                        errors.length > 0
                                                          ? "border-red-400"
                                                          : _vm.company.name
                                                          ? "border-green-600"
                                                          : "border-gray-300",
                                                      attrs: {
                                                        type: "text",
                                                        name: "organization_name",
                                                        id: "organization_name",
                                                        disabled:
                                                          !_vm.isMainRegister,
                                                      },
                                                      domProps: {
                                                        value: _vm.company.name,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          )
                                                            return
                                                          _vm.$set(
                                                            _vm.company,
                                                            "name",
                                                            $event.target.value
                                                          )
                                                        },
                                                      },
                                                    }),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "md:col-span-1 col-span-2",
                                      },
                                      [
                                        _c(
                                          "label",
                                          {
                                            staticClass:
                                              "block mb-1 text-sm font-medium text-gray-700",
                                            attrs: { for: "position" },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "position-at-organization"
                                                )
                                              ) + "*"
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("ValidationProvider", {
                                          attrs: {
                                            name: "position",
                                            rules: "required",
                                            mode: "eager",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function ({ errors }) {
                                                  return [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.company
                                                              .position,
                                                          expression:
                                                            "company.position",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "focus:outline-none appearance-none block w-full px-3 py-2 border rounded-md shadow-sm placeholder-gray-400 sm:text-sm",
                                                      class:
                                                        errors.length > 0
                                                          ? "border-red-400"
                                                          : _vm.company.position
                                                          ? "border-green-600"
                                                          : "border-gray-300",
                                                      attrs: {
                                                        type: "text",
                                                        name: "position",
                                                        id: "position",
                                                        disabled:
                                                          !_vm.isMainRegister,
                                                      },
                                                      domProps: {
                                                        value:
                                                          _vm.company.position,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          )
                                                            return
                                                          _vm.$set(
                                                            _vm.company,
                                                            "position",
                                                            $event.target.value
                                                          )
                                                        },
                                                      },
                                                    }),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "md:col-span-1 col-span-2",
                                      },
                                      [
                                        _c(
                                          "label",
                                          {
                                            staticClass:
                                              "block mb-1 text-sm font-medium text-gray-700",
                                            attrs: { for: "phone" },
                                          },
                                          [_vm._v(_vm._s(_vm.$t("phone")))]
                                        ),
                                        _vm._v(" "),
                                        _c("ValidationProvider", {
                                          attrs: {
                                            rules: {
                                              required: true,
                                              length: 16,
                                            },
                                            name: "phone",
                                            mode: "eager",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function ({ errors }) {
                                                  return [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.company.phone,
                                                          expression:
                                                            "company.phone",
                                                        },
                                                        {
                                                          name: "mask",
                                                          rawName: "v-mask",
                                                          value:
                                                            "+##### ###-##-##",
                                                          expression:
                                                            "'+##### ###-##-##'",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "focus:outline-none appearance-none block w-full px-3 py-2 border rounded-md shadow-sm placeholder-gray-400 sm:text-sm",
                                                      class:
                                                        errors.length > 0
                                                          ? "border-red-400"
                                                          : _vm.company.phone
                                                          ? "border-green-600"
                                                          : "border-gray-300",
                                                      attrs: {
                                                        type: "text",
                                                        name: "phone",
                                                        id: "phone",
                                                        disabled:
                                                          !_vm.isMainRegister,
                                                      },
                                                      domProps: {
                                                        value:
                                                          _vm.company.phone,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          )
                                                            return
                                                          _vm.$set(
                                                            _vm.company,
                                                            "phone",
                                                            $event.target.value
                                                          )
                                                        },
                                                      },
                                                    }),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "md:col-span-1 col-span-2",
                                      },
                                      [
                                        _c(
                                          "label",
                                          {
                                            staticClass:
                                              "block mb-1 text-sm font-medium text-gray-700",
                                            attrs: { for: "email" },
                                          },
                                          [_vm._v(_vm._s(_vm.$t("email")))]
                                        ),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.company.email,
                                              expression: "company.email",
                                            },
                                          ],
                                          staticClass:
                                            "focus:outline-none appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 sm:text-sm",
                                          attrs: {
                                            type: "email",
                                            name: "email",
                                            id: "email",
                                            disabled: !_vm.isMainRegister,
                                          },
                                          domProps: {
                                            value: _vm.company.email,
                                          },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                _vm.company,
                                                "email",
                                                $event.target.value
                                              )
                                            },
                                          },
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "col-span-2" }, [
                                      _c(
                                        "label",
                                        {
                                          staticClass:
                                            "block mb-1 text-sm font-medium text-gray-700",
                                          attrs: { for: "summary" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("short-summary"))
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("textarea", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.company.shortinfo,
                                            expression: "company.shortinfo",
                                          },
                                        ],
                                        staticClass:
                                          "focus:outline-none appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 sm:text-sm",
                                        attrs: {
                                          type: "text",
                                          name: "summary",
                                          id: "summary",
                                          rows: "4",
                                          disabled: !_vm.isMainRegister,
                                          placeholder: _vm.$t(
                                            "short-summary-of-agricultural-environmental-experience-and-activities-of-organization-in-Karakalpakstan"
                                          ),
                                        },
                                        domProps: {
                                          value: _vm.company.shortinfo,
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              _vm.company,
                                              "shortinfo",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "col-span-2" }, [
                                      _c(
                                        "label",
                                        {
                                          staticClass:
                                            "block mb-1 text-sm font-medium text-gray-700",
                                          attrs: { for: "description" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("short-description"))
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("textarea", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.company.fullinfo,
                                            expression: "company.fullinfo",
                                          },
                                        ],
                                        staticClass:
                                          "focus:outline-none appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 sm:text-sm",
                                        attrs: {
                                          type: "text",
                                          name: "description",
                                          id: "description",
                                          rows: "4",
                                          disabled: !_vm.isMainRegister,
                                          placeholder: _vm.$t(
                                            "short-description-of-organization-size-relationship-to-agricultural-environmental-sectors-in-Karakalpakstan"
                                          ),
                                        },
                                        domProps: {
                                          value: _vm.company.fullinfo,
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              _vm.company,
                                              "fullinfo",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                    ]),
                                    _vm._v(" "),
                                    _c("ValidationProvider", {
                                      attrs: {
                                        name: "checked",
                                        rules: "checked",
                                        mode: "eager",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({}) {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "flex items-center mt-2 col-span-2",
                                                  },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value: _vm.isAgree,
                                                          expression: "isAgree",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "h-5 w-5 text-green-600 focus:ring-green-600 border-gray-300 rounded",
                                                      attrs: {
                                                        name: "termsOfUse",
                                                        type: "checkbox",
                                                        disabled:
                                                          !_vm.isMainRegister,
                                                      },
                                                      domProps: {
                                                        value: true,
                                                        checked: Array.isArray(
                                                          _vm.isAgree
                                                        )
                                                          ? _vm._i(
                                                              _vm.isAgree,
                                                              true
                                                            ) > -1
                                                          : _vm.isAgree,
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          var $$a = _vm.isAgree,
                                                            $$el =
                                                              $event.target,
                                                            $$c = $$el.checked
                                                              ? true
                                                              : false
                                                          if (
                                                            Array.isArray($$a)
                                                          ) {
                                                            var $$v = true,
                                                              $$i = _vm._i(
                                                                $$a,
                                                                $$v
                                                              )
                                                            if ($$el.checked) {
                                                              $$i < 0 &&
                                                                (_vm.isAgree =
                                                                  $$a.concat([
                                                                    $$v,
                                                                  ]))
                                                            } else {
                                                              $$i > -1 &&
                                                                (_vm.isAgree =
                                                                  $$a
                                                                    .slice(
                                                                      0,
                                                                      $$i
                                                                    )
                                                                    .concat(
                                                                      $$a.slice(
                                                                        $$i + 1
                                                                      )
                                                                    ))
                                                            }
                                                          } else {
                                                            _vm.isAgree = $$c
                                                          }
                                                        },
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "ml-2 block text-gray-600 text-base",
                                                        attrs: {
                                                          for: "termsOfUse",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                  " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "i-agree-with"
                                                              )
                                                            ) +
                                                            "\n                  "
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "text-green-600 border-b border-green-600",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                    " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "terms-of-use"
                                                                  )
                                                                ) +
                                                                "\n                  "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "col-span-2 rounded-md py-3 mt-6",
                                        class: invalid
                                          ? "bg-gray-300"
                                          : "bg-green-600 hover:bg-green-700 text-white",
                                        attrs: { disabled: invalid },
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(_vm.$t("register")) +
                                            "\n            "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    280925895
                  ),
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }